export var MAX_REPEATS_X = Infinity;
export var MAX_REPEATS_Y = Infinity;
export var binsx = 1000;
export var binsy = 500;
